import { checkoutFlow } from '../constants/common';
import { AMEX, DISCOVER, MA, idReferences, VISA } from '../constants/partnering-networks';
import collapsedLogger from '../helpers/collapsed-logger';
import getFormattedSRCNetworks from '../helpers/get-formatted-src-networks';
import getUnloadedSdks from '../helpers/get-unloaded-sdk';
import logger from '../helpers/logger';
import OrchCustomData from '../helpers/orch-custom-data';

/**
 * Remove the loaded INO partner network scripts
 * @param {string} key
 */
const unloadSDKFile = key => {
  if (key !== '') {
    const id = idReferences[key];
    const existingScript = document.getElementById(id);
    const parentNode = existingScript.parentNode;
    parentNode.removeChild(existingScript);
    if (key === MA) {
      window.SRCSDK_MASTERCARD = null;
    }
    if (key === AMEX) {
      window.AmexSS.getInstance = null;
    }
    if (key === DISCOVER) {
      window.DGNCheckout.getInstance = null;
    }
  }
};

/**
 * Remove the cached reference from orch layer for loaded Sdk, isRecognized
 * @param {string} key
 */
const removeCachedReference = key => {
  //remove loaded Sdk reference which is not required if specific network is unloaded
  delete OrchCustomData.srcSdks.loadedSdk[key];
  //remove isRecognized reference which was set initially during button load
  delete OrchCustomData.srcSdks.apiResponseCache.isRecognized[key];
};

/* Based on showVdcpIno flag Orchestartion layer should set participating networks
 * by default showVdcpIno will be false and no INO experience
 * remove all sdk instances from OrchCustomData and unload all scripts references
 */
const handleSdkInit = data => {
  logger('handleSdkInit', data);
  const { futSRCNetworks, showVdcpIno, xoFlow } = data;
  const futSRCNetworksFormatted = getFormattedSRCNetworks(futSRCNetworks);
  //Pre-loaded SDKs from srcInfo object
  const loadedSdks = OrchCustomData.srcSdks?.loadedSdk ?? null;
  //Need to unload sdks other than futSRCNetworks
  const shouldUnloadSdkforFut =
    showVdcpIno && (futSRCNetworksFormatted && Object.keys(futSRCNetworksFormatted).length) >= 1;
  const shouldUnloadSdkforVDCP =
    (typeof showVdcpIno === 'boolean' && !showVdcpIno) ||
    (xoFlow && xoFlow.toUpperCase() !== checkoutFlow.SRC);
  //Update Ino Decision to system sdk.
  OrchCustomData.setShowVdcpIno(showVdcpIno);
  const vSdkInstance = loadedSdks[VISA];
  if (vSdkInstance) {
    vSdkInstance.updateVdcpConfig(data);
  }
  // VCO-14507 don't overwrite preferred network if it was set
  if (!OrchCustomData.srcSdks.orchConfig.preferredNetwork) {
    OrchCustomData.srcSdks.orchConfig.preferredNetwork = VISA;
  }
  if (shouldUnloadSdkforVDCP || shouldUnloadSdkforFut) {
    //find out the netowrks to be unloaded from srcInfo list based on futSRCNetworks
    const networksToUnload = shouldUnloadSdkforFut ? getUnloadedSdks(futSRCNetworksFormatted) : [];
    if (loadedSdks) {
      Object.keys(loadedSdks).forEach((key, index) => {
        logger('Pre-loadedSdks index =', index);
        logger('Pre-loadedSdks key =', key);
        if (showVdcpIno === false || (showVdcpIno && networksToUnload.includes(key))) {
          if (key !== VISA) {
            //(#1)unload external sdks and (#2)reset orch custom object for ext sdks
            unloadSDKFile(key);
            removeCachedReference(key);
            OrchCustomData.removeNetwork(key);
          }
        }
      });
    }
  }
  collapsedLogger('Finally loaded SDKs ---> ', OrchCustomData?.srcSdks?.loadedSdk ?? null);
  collapsedLogger('End handleSdkInit OrchCustomData ---> ', OrchCustomData);
};

export default handleSdkInit;
